import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg width={props.width || '1em'} height={props.height || '1em'} fill="none" {...props} viewBox="0 0 28 27">
		<g stroke={props.color || 'var(--icon)'} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} clipPath="url(#a)">
			<path d="M18.375.844h-8.75C8.175.844 7 1.977 7 3.375v20.25c0 1.398 1.175 2.531 2.625 2.531h8.75c1.45 0 2.625-1.133 2.625-2.531V3.375C21 1.977 19.825.844 18.375.844Z" />
			<path d="M9.625.844h1.313c.115 0 .227.044.309.123.082.08.128.187.128.299 0 .223.092.438.256.596a.892.892 0 0 0 .619.247h3.5a.892.892 0 0 0 .619-.247.829.829 0 0 0 .256-.596c0-.112.046-.22.128-.299a.446.446 0 0 1 .31-.123h1.312" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill={props.color || 'var(--icon)'} d="M0 0h28v27H0z" />
			</clipPath>
		</defs>
	</svg>
);
export default SvgComponent;
